import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["token"]

  connect() {
    this.sync()
  }

  sync() {
    const csrfToken = this.readMetaToken()
    if (!csrfToken) return

    if (this.hasTokenTarget) {
      this.tokenTargets.forEach((input) => {
        input.value = csrfToken
      })
      return
    }

    const input = document.createElement("input")
    input.type = "hidden"
    input.name = "authenticity_token"
    input.value = csrfToken
    this.element.prepend(input)
  }

  readMetaToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta?.getAttribute("content")?.trim() || null
  }
}
